<div class="loader"><mat-spinner class="publish-spinner" color="primary"></mat-spinner><span class="text">{{ message }}</span>
    <div class="progress-meta" *ngIf="progress.totalRecords > 0">
        {{progress.processedRecords}} / {{progress.totalRecords}} records
    </div>
    <div class="progress-track" *ngIf="progress.totalRecords > 0">
        <div class="progress-fill"
            [ngClass]="progressStatusClass"
            [style.width.%]="progressPercent">
        </div>
    </div>
    <div class="progress-legend" *ngIf="progress.totalRecords > 0">
        <span class="legend-item"><span class="legend-dot status-success"></span>No issues encountered</span>
        <span class="legend-item"><span class="legend-dot status-failed"></span>Some records failed due to network issues</span>
    </div>
    <div class="network-bulb" [title]="networkOnline ? 'Network Online' : 'Network Offline'">
        <span class="network-label">Network Status</span>
        <span class="bulb" [ngClass]="networkOnline ? 'online' : 'offline'"></span>
    </div>
    <div class="final-message" *ngIf="requireAcknowledgement && !!finalMessage">{{finalMessage}}</div>
    <button *ngIf="requireAcknowledgement" class="ack-button" (click)="acknowledgeFinalStatus()">OK</button>
    <div class="loader-note"> <span class="font-semibold">Note: </span> <span class="italic">Please do not close until the process is completed.</span> </div>
</div>